import React, { FC, useRef } from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';
import { Amenity } from '../../../domain/models/Amenity';
import { AmenityButton } from './AmenityButton';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { capitalize } from '../../../../shared/utils/capitalize';

interface IAmenityFilterProps {
	onToggleAmenity: (amenity: Amenity) => void;
	currentAmenities: Amenity[];
}

export const AmenityFilter: FC<IAmenityFilterProps> = ({
	currentAmenities,
	onToggleAmenity,
}) => {
	const { t } = useTranslation();
	const buttonsHolderRef = useRef<HTMLDivElement>(null);
	const amenities: Amenity[] = Object.values(Amenity);

	return (
		<AmenityWrapper>
			<FilterText>{t('shop_dine_amenity_filter')}</FilterText>
			<ButtonsWrapper ref={buttonsHolderRef}>
				{amenities.map((amenity) => (
					<AmenityButton
						key={amenity}
						selected={currentAmenities.includes(amenity)}
						onToggle={() => onToggleAmenity(amenity)}
						amenity={amenity}
					>
						<AmenityButtonText selected={currentAmenities.includes(amenity)}>
							{capitalize(amenity)}
						</AmenityButtonText>
					</AmenityButton>
				))}
			</ButtonsWrapper>
		</AmenityWrapper>
	);
};

const AmenityWrapper = styled.div`
	display: flex;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	margin-top: 16px;
	flex-direction: row;
	align-items: center;
`;

const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		min-width: max-content;
	}
`;

const AmenityButtonText = styled.p<{ selected: boolean }>`
	font-size: 16px;
	width: max-content;
	margin-right: 8px;
	-webkit-text-stroke-width: ${({ selected }) => (selected ? '0.6px' : 0)};
	-webkit-text-stroke-color: black;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-right: 3px;
	}
`;

const FilterText = styled.div`
	font-size: 16px;
	font-weight: 400;
	line-height: 40px;
`;
